import { BonusCardStatus, CustomerTypes } from "@utils/enums";

import * as BonusCardService from "@services/bonusCard.service";

import { IState } from "@redux/store.types";
import { generateDefaultSelectors, getApiDataState } from "@redux/utils";

import { $CustomerModuleName } from "./customer.types";

const { isLoading, error, isSuccessfullyLoaded } =
    generateDefaultSelectors($CustomerModuleName);

const getState = (state: IState) =>
    getApiDataState(state, $CustomerModuleName)?.data;

const getCustomer = (state: IState) => {
    return getState(state);
};

const getBonusCardStatus = (state: IState) => {
    const customerState = getState(state);

    return customerState
        ? BonusCardService.getStatus(customerState)
        : BonusCardStatus.NoCard;
};

const isCustomerFilledIn = (state: IState) => {
    const customer = getCustomer(state);
    return (
        customer?.firstName &&
        customer?.lastName &&
        customer?.phone &&
        (customer?.customerType === CustomerTypes.B2B
            ? customer?.vatNr && customer?.companyName
            : true)
    );
};

export {
    isSuccessfullyLoaded,
    isLoading,
    error,
    getCustomer,
    getBonusCardStatus,
    isCustomerFilledIn,
};
